import { type PagedResponse } from 'types/paged-response'
import { type MultiValueTags } from 'types/tags'

export enum AgentType {
  INFRASTRUCTURE = 'Infrastructure',
  FAILURE_FLAG = 'FailureFlag'
}

export enum AgentStatus {
  ACTIVE = 'Active',
  DEACTIVATED = 'Deactivated',
  IDLE = 'Idle'
}

export type Agent = {
  id: string
  name: string
  status: AgentStatus
  type: AgentType
  warningCount: number
  tags: MultiValueTags
}

export type PagedAgentsResponse = PagedResponse<Agent>

export type AgentSummaryResponse = {
  active: number
  warnings: number
  deactivated: number
  idle: number
}
